/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import TermsOfServiceLegalbirdOSPageMeta from "./TermsOfServiceLegalbirdOSPageMeta";
import Container from "../../../../../components/Container/Container";
import Layout from "../../../../Layouts/Layout";
import TermsOfServiceLegalbirdOS from "../../../../../components/TermsOfService/TermsOfServiceLegalbirdOS/TermsOfServiceLegalbirdOS";

const TermsOfServiceLegalbirdOSPage = () => {
  return (
    <Layout backgroundType={"landingpage"}>
      <TermsOfServiceLegalbirdOSPageMeta />
      <Container showPaddingBlock={false}>
        <TermsOfServiceLegalbirdOS />
      </Container>
    </Layout>
  );
};

export default TermsOfServiceLegalbirdOSPage;
